import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * TextMask component.
 *
 * @author Mikhail Siutsou
 * @function TextMask
 * @category components
 * @return {JSX.Element} TextMask component.
 */
var TextMask = /*#__PURE__*/forwardRef(function (props, ref) {
  var onChange = props.onChange,
      restProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsx(IMaskInput, _objectSpread({
    onAccept: function onAccept(_, maskValue) {
      onChange(maskValue.unmaskedValue);
    },
    inputRef: function inputRef() {
      return ref;
    }
  }, restProps));
});
TextMask.displayName = 'TextMask';
export { TextMask };